import React, { useCallback, useEffect } from 'react';
import {
  Route as ReactDOMRoute,
  RouteProps as ReactDOMRouteProps,
  Redirect,
  useLocation,
} from 'react-router-dom';

import { useAuth } from '../hooks/auth';

interface RouteProps extends ReactDOMRouteProps {
  isPrivate?: boolean;
  isAgency?: boolean;
  component: React.ComponentType;
}

const Route: React.FC<RouteProps> = ({
  isPrivate = false,
  isAgency = false,
  component: Component,
  ...rest
}) => {
  const { user } = useAuth();

  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  const canView = useCallback(() => {
    if (user) {
      if (isAgency && !user.agency) {
        return (
          <Redirect
            to={{
              pathname: `/dashboard`,
              state: { referrer: pathname },
            }}
          />
        );
      }
      return <Component />;
    }
    if (isPrivate) {
      return (
        <Redirect
          to={{
            pathname: `/login`,
            state: { referrer: pathname },
          }}
        />
      );
    }
    return <Component />;
  }, [Component, isAgency, isPrivate, pathname, user]);

  return (
    <>
      <ReactDOMRoute {...rest} render={canView} />
    </>
  );
};

export default Route;
